
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function MembershipSection() {
  const navigate = useNavigate();

  const membershipTypes = [
    {
      title: "Pharmacists",
      description: "Join a community of pharmacy professionals dedicated to advancing patient care and professional excellence.",
      icon: "ri-medicine-bottle-line",
      color: "blue",
      benefits: ["Professional Development", "Advocacy Support", "Networking Opportunities", "Continuing Education"]
    },
    {
      title: "Veterinarians", 
      description: "Connect with veterinary professionals committed to animal health and cross-disciplinary collaboration.",
      icon: "ri-heart-pulse-line",
      color: "green",
      benefits: ["Clinical Resources", "Research Access", "Professional Networks", "Training Programs"]
    },
    {
      title: "Patients & Pet Owners",
      description: "Access resources, support, and advocacy for both human and animal health needs.",
      icon: "ri-user-heart-line",
      color: "purple", 
      benefits: ["Health Resources", "Educational Materials", "Support Networks", "Advocacy Services"]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Membership
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join our diverse community of healthcare professionals and advocates working together for better health outcomes.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {membershipTypes.map((type, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className={`w-16 h-16 bg-${type.color}-100 rounded-full flex items-center justify-center mx-auto mb-6`}>
                <i className={`${type.icon} text-2xl text-${type.color}-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 text-center mb-4">
                {type.title}
              </h3>
              <p className="text-gray-600 text-center mb-6">
                {type.description}
              </p>
              <ul className="space-y-2 mb-8">
                {type.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {benefit}
                  </li>
                ))}
              </ul>
              <Button variant="outline" className="w-full" onClick={() => navigate('/membership')}>
                Learn More
              </Button>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <Button size="lg" onClick={() => navigate('/membership')}>
            Explore Membership Options
          </Button>
        </div>
      </div>
    </section>
  );
}
